/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Company } from '../models';
// @ts-ignore
import { CreateDamageCase } from '../models';
// @ts-ignore
import { DamageCase } from '../models';
// @ts-ignore
import { DamageCaseComprehensive } from '../models';
// @ts-ignore
import { DamagecasesIdRepairextensionsEmailLawyerOfficePostRequest } from '../models';
// @ts-ignore
import { DamagecasesIdWorkingimagesDownloadPostRequest } from '../models';
// @ts-ignore
import { Document } from '../models';
// @ts-ignore
import { DocumentSign } from '../models';
// @ts-ignore
import { MetaInfoFile } from '../models';
// @ts-ignore
import { PDFTypes } from '../models';
// @ts-ignore
import { PdfDamagecasesTypeTempSavePost200Response } from '../models';
// @ts-ignore
import { RepairExtension } from '../models';
// @ts-ignore
import { RepairProof } from '../models';
// @ts-ignore
import { WorkingImages } from '../models';
/**
 * DamagecasesApi - axios parameter creator
 * @export
 */
export const DamagecasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new damage case
         * @param {CreateDamageCase} createDamageCase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDamageCases: async (createDamageCase: CreateDamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDamageCase' is not null or undefined
            assertParamExists('createDamageCases', 'createDamageCase', createDamageCase)
            const localVarPath = `/damagecases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDamageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create damage case (comprehensive)
         * @param {DamageCaseComprehensive} [damageCaseComprehensive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesComprehensivePost: async (damageCaseComprehensive?: DamageCaseComprehensive, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/damagecases/comprehensive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCaseComprehensive, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all damage cases
         * @param {number} [page] Pagenumber
         * @param {number} [perPage] Items shown per page
         * @param {string} [sort] Column to Sort example: date_of_accident, for desc -date_of_accident
         * @param {string} [filterDaterange] Daterangefilter e.g. 1600696856-1620692324
         * @param {string} [filterYear] Yearfilter e.g. 2020
         * @param {string} [filterStatus] 
         * @param {string} [filterDamageAssessorReferenceNumber] 
         * @param {string} [filterLawyersOfficeReferenceNumber] 
         * @param {string} [filterRepairShopReferenceNumber] 
         * @param {string} [filterVehicles] 
         * @param {string} [filterImdNet] 
         * @param {number} [filterCustomer] 
         * @param {string} [filterPayment] 
         * @param {string} [filterDamageAssessor] 
         * @param {string} [filterRepairshop] 
         * @param {string} [filterIntermediary] 
         * @param {string} [filterIsEmployee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesGet: async (page?: number, perPage?: number, sort?: string, filterDaterange?: string, filterYear?: string, filterStatus?: string, filterDamageAssessorReferenceNumber?: string, filterLawyersOfficeReferenceNumber?: string, filterRepairShopReferenceNumber?: string, filterVehicles?: string, filterImdNet?: string, filterCustomer?: number, filterPayment?: string, filterDamageAssessor?: string, filterRepairshop?: string, filterIntermediary?: string, filterIsEmployee?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/damagecases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterDaterange !== undefined) {
                localVarQueryParameter['filter[daterange]'] = filterDaterange;
            }

            if (filterYear !== undefined) {
                localVarQueryParameter['filter[year]'] = filterYear;
            }

            if (filterStatus !== undefined) {
                localVarQueryParameter['filter[status]'] = filterStatus;
            }

            if (filterDamageAssessorReferenceNumber !== undefined) {
                localVarQueryParameter['filter[damage_assessor_reference_number]'] = filterDamageAssessorReferenceNumber;
            }

            if (filterLawyersOfficeReferenceNumber !== undefined) {
                localVarQueryParameter['filter[lawyers_office_reference_number]'] = filterLawyersOfficeReferenceNumber;
            }

            if (filterRepairShopReferenceNumber !== undefined) {
                localVarQueryParameter['filter[repair_shop_reference_number]'] = filterRepairShopReferenceNumber;
            }

            if (filterVehicles !== undefined) {
                localVarQueryParameter['filter[vehicles]'] = filterVehicles;
            }

            if (filterImdNet !== undefined) {
                localVarQueryParameter['filter[imd_net]'] = filterImdNet;
            }

            if (filterCustomer !== undefined) {
                localVarQueryParameter['filter[customer]'] = filterCustomer;
            }

            if (filterPayment !== undefined) {
                localVarQueryParameter['filter[payment]'] = filterPayment;
            }

            if (filterDamageAssessor !== undefined) {
                localVarQueryParameter['filter[damage_assessor]'] = filterDamageAssessor;
            }

            if (filterRepairshop !== undefined) {
                localVarQueryParameter['filter[repairshop]'] = filterRepairshop;
            }

            if (filterIntermediary !== undefined) {
                localVarQueryParameter['filter[intermediary]'] = filterIntermediary;
            }

            if (filterIsEmployee !== undefined) {
                localVarQueryParameter['filter[isEmployee]'] = filterIsEmployee;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update CustomerConsultant in DamageCase
         * @param {number} id 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdCustomerConsultantPut: async (id: number, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdCustomerConsultantPut', 'id', id)
            const localVarPath = `/damagecases/{id}/customerConsultant`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the file of the document
         * @param {number} id 
         * @param {number} docid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsDocidFileGet: async (id: number, docid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdDocumentsDocidFileGet', 'id', id)
            // verify required parameter 'docid' is not null or undefined
            assertParamExists('damagecasesIdDocumentsDocidFileGet', 'docid', docid)
            const localVarPath = `/damagecases/{id}/documents/{docid}/file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"docid"}}`, encodeURIComponent(String(docid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload the file of the document
         * @param {number} id 
         * @param {number} docid 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsDocidFilePost: async (id: number, docid: number, body?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdDocumentsDocidFilePost', 'id', id)
            // verify required parameter 'docid' is not null or undefined
            assertParamExists('damagecasesIdDocumentsDocidFilePost', 'docid', docid)
            const localVarPath = `/damagecases/{id}/documents/{docid}/file`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"docid"}}`, encodeURIComponent(String(docid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/pdf';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific docuemnt for a specific damagecase
         * @param {number} id 
         * @param {number} docid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsDocidGet: async (id: number, docid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdDocumentsDocidGet', 'id', id)
            // verify required parameter 'docid' is not null or undefined
            assertParamExists('damagecasesIdDocumentsDocidGet', 'docid', docid)
            const localVarPath = `/damagecases/{id}/documents/{docid}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"docid"}}`, encodeURIComponent(String(docid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific docuemnt for a specific damagecase
         * @param {number} id 
         * @param {number} docid 
         * @param {Document} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsDocidPut: async (id: number, docid: number, document: Document, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdDocumentsDocidPut', 'id', id)
            // verify required parameter 'docid' is not null or undefined
            assertParamExists('damagecasesIdDocumentsDocidPut', 'docid', docid)
            // verify required parameter 'document' is not null or undefined
            assertParamExists('damagecasesIdDocumentsDocidPut', 'document', document)
            const localVarPath = `/damagecases/{id}/documents/{docid}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"docid"}}`, encodeURIComponent(String(docid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(document, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all documents of a specific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdDocumentsGet', 'id', id)
            const localVarPath = `/damagecases/{id}/documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new DokumentDTO for a specific damage case
         * @param {number} id 
         * @param {Document} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsPost: async (id: number, document: Document, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdDocumentsPost', 'id', id)
            // verify required parameter 'document' is not null or undefined
            assertParamExists('damagecasesIdDocumentsPost', 'document', document)
            const localVarPath = `/damagecases/{id}/documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(document, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the file of the document
         * @param {number} id 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsTypeGet: async (id: number, type: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdDocumentsTypeGet', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('damagecasesIdDocumentsTypeGet', 'type', type)
            const localVarPath = `/damagecases/{id}/documents/{type}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mail all documents of damagecase
         * @param {number} id The id of the damageCase to retrieve
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdEmailEmailGet: async (id: number, email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdEmailEmailGet', 'id', id)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('damagecasesIdEmailEmailGet', 'email', email)
            const localVarPath = `/damagecases/{id}/email/{email}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mail all updated documents of damagecase
         * @param {number} id The id of the damageCase to retrieve
         * @param {string} email 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdEmailEmailUpdatePost: async (id: number, email: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdEmailEmailUpdatePost', 'id', id)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('damagecasesIdEmailEmailUpdatePost', 'email', email)
            const localVarPath = `/damagecases/{id}/email/{email}/update`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific damage case
         * @param {number} id The id of the damageCase to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdGet', 'id', id)
            const localVarPath = `/damagecases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to download all types of images of a specific damage case
         * @param {number} id 
         * @param {'thumbnail' | 'workingimages'} imageType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdImageTypeGet: async (id: number, imageType: 'thumbnail' | 'workingimages', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdImageTypeGet', 'id', id)
            // verify required parameter 'imageType' is not null or undefined
            assertParamExists('damagecasesIdImageTypeGet', 'imageType', imageType)
            const localVarPath = `/damagecases/{id}/{imageType}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"imageType"}}`, encodeURIComponent(String(imageType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload the thumbnail of a specific damage case
         * @param {number} id 
         * @param {'thumbnail' | 'workingimages'} imageType 
         * @param {MetaInfoFile} metaInfoFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdImageTypePost: async (id: number, imageType: 'thumbnail' | 'workingimages', metaInfoFile: MetaInfoFile, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdImageTypePost', 'id', id)
            // verify required parameter 'imageType' is not null or undefined
            assertParamExists('damagecasesIdImageTypePost', 'imageType', imageType)
            // verify required parameter 'metaInfoFile' is not null or undefined
            assertParamExists('damagecasesIdImageTypePost', 'metaInfoFile', metaInfoFile)
            const localVarPath = `/damagecases/{id}/{imageType}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"imageType"}}`, encodeURIComponent(String(imageType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metaInfoFile, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific lawyer office
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdLawyerOfficePut: async (id: number, company?: Company, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdLawyerOfficePut', 'id', id)
            const localVarPath = `/damagecases/{id}/lawyerOffice`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove lawyer office
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdLawyerOfficeRemovePut: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdLawyerOfficeRemovePut', 'id', id)
            const localVarPath = `/damagecases/{id}/lawyerOffice/remove`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update damagecase note
         * @param {number} id 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdNotePut: async (id: number, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdNotePut', 'id', id)
            const localVarPath = `/damagecases/{id}/note`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific opposite Insurances
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdOppositeInsurancePut: async (id: number, company?: Company, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdOppositeInsurancePut', 'id', id)
            const localVarPath = `/damagecases/{id}/oppositeInsurance`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific damage case
         * @param {number} id 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdPut: async (id: number, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdPut', 'id', id)
            const localVarPath = `/damagecases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific RepairShop
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairShopPut: async (id: number, company?: Company, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRepairShopPut', 'id', id)
            const localVarPath = `/damagecases/{id}/repairShop`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sent E-Mail to context-Lawyer
         * @param {number} id 
         * @param {DamagecasesIdRepairextensionsEmailLawyerOfficePostRequest} damagecasesIdRepairextensionsEmailLawyerOfficePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsEmailLawyerOfficePost: async (id: number, damagecasesIdRepairextensionsEmailLawyerOfficePostRequest: DamagecasesIdRepairextensionsEmailLawyerOfficePostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsEmailLawyerOfficePost', 'id', id)
            // verify required parameter 'damagecasesIdRepairextensionsEmailLawyerOfficePostRequest' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsEmailLawyerOfficePost', 'damagecasesIdRepairextensionsEmailLawyerOfficePostRequest', damagecasesIdRepairextensionsEmailLawyerOfficePostRequest)
            const localVarPath = `/damagecases/{id}/repairextensions/email/lawyer_office`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damagecasesIdRepairextensionsEmailLawyerOfficePostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to get a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsExtidGet: async (id: number, extid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidGet', 'id', id)
            // verify required parameter 'extid' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidGet', 'extid', extid)
            const localVarPath = `/damagecases/{id}/repairextensions/{extid}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"extid"}}`, encodeURIComponent(String(extid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to get a secific collection of media as a zip of a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {DamagecasesIdWorkingimagesDownloadPostRequest} damagecasesIdWorkingimagesDownloadPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsExtidMediafilesDownloadGet: async (id: number, extid: number, damagecasesIdWorkingimagesDownloadPostRequest: DamagecasesIdWorkingimagesDownloadPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidMediafilesDownloadGet', 'id', id)
            // verify required parameter 'extid' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidMediafilesDownloadGet', 'extid', extid)
            // verify required parameter 'damagecasesIdWorkingimagesDownloadPostRequest' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidMediafilesDownloadGet', 'damagecasesIdWorkingimagesDownloadPostRequest', damagecasesIdWorkingimagesDownloadPostRequest)
            const localVarPath = `/damagecases/{id}/repairextensions/{extid}/mediafiles/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"extid"}}`, encodeURIComponent(String(extid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarRequestOptions.responseType = 'arraybuffer'

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damagecasesIdWorkingimagesDownloadPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to get all media files of a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsExtidMediafilesGet: async (id: number, extid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidMediafilesGet', 'id', id)
            // verify required parameter 'extid' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidMediafilesGet', 'extid', extid)
            const localVarPath = `/damagecases/{id}/repairextensions/{extid}/mediafiles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"extid"}}`, encodeURIComponent(String(extid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to upload a media-file to a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {MetaInfoFile} metaInfoFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsExtidMediafilesPost: async (id: number, extid: number, metaInfoFile: MetaInfoFile, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidMediafilesPost', 'id', id)
            // verify required parameter 'extid' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidMediafilesPost', 'extid', extid)
            // verify required parameter 'metaInfoFile' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidMediafilesPost', 'metaInfoFile', metaInfoFile)
            const localVarPath = `/damagecases/{id}/repairextensions/{extid}/mediafiles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"extid"}}`, encodeURIComponent(String(extid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metaInfoFile, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to update a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {RepairExtension} repairExtension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsExtidPut: async (id: number, extid: number, repairExtension: RepairExtension, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidPut', 'id', id)
            // verify required parameter 'extid' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidPut', 'extid', extid)
            // verify required parameter 'repairExtension' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsExtidPut', 'repairExtension', repairExtension)
            const localVarPath = `/damagecases/{id}/repairextensions/{extid}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"extid"}}`, encodeURIComponent(String(extid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairExtension, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to get all repair extensions of a specific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsGet', 'id', id)
            const localVarPath = `/damagecases/{id}/repairextensions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to add a new repair extension to a damage case
         * @param {number} id 
         * @param {RepairExtension} repairExtension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsPost: async (id: number, repairExtension: RepairExtension, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsPost', 'id', id)
            // verify required parameter 'repairExtension' is not null or undefined
            assertParamExists('damagecasesIdRepairextensionsPost', 'repairExtension', repairExtension)
            const localVarPath = `/damagecases/{id}/repairextensions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairExtension, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to download all images of the repair proof to a secific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairproofDownloadGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRepairproofDownloadGet', 'id', id)
            const localVarPath = `/damagecases/{id}/repairproof/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.responseType = 'arraybuffer'

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to download the repair proof of a specific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairproofGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRepairproofGet', 'id', id)
            const localVarPath = `/damagecases/{id}/repairproof`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload the repair proof of a specific damage case
         * @param {number} id 
         * @param {RepairProof} repairProof 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairproofPost: async (id: number, repairProof: RepairProof, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdRepairproofPost', 'id', id)
            // verify required parameter 'repairProof' is not null or undefined
            assertParamExists('damagecasesIdRepairproofPost', 'repairProof', repairProof)
            const localVarPath = `/damagecases/{id}/repairproof`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairProof, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Text from api
         * @param {string} type 
         * @param {number} id The id of the damageCase to retrieve
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdTextgeneratorTypePost: async (type: string, id: number, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('damagecasesIdTextgeneratorTypePost', 'type', type)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdTextgeneratorTypePost', 'id', id)
            const localVarPath = `/damagecases/{id}/textgenerator/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to delete a workingimage
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdWorkingimagesDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdWorkingimagesDelete', 'id', id)
            const localVarPath = `/damagecases/{id}/workingimages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to get a secific collection of workingimges as a zip of a specific damage case
         * @param {number} id 
         * @param {DamagecasesIdWorkingimagesDownloadPostRequest} damagecasesIdWorkingimagesDownloadPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdWorkingimagesDownloadPost: async (id: number, damagecasesIdWorkingimagesDownloadPostRequest: DamagecasesIdWorkingimagesDownloadPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdWorkingimagesDownloadPost', 'id', id)
            // verify required parameter 'damagecasesIdWorkingimagesDownloadPostRequest' is not null or undefined
            assertParamExists('damagecasesIdWorkingimagesDownloadPost', 'damagecasesIdWorkingimagesDownloadPostRequest', damagecasesIdWorkingimagesDownloadPostRequest)
            const localVarPath = `/damagecases/{id}/workingimages/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarRequestOptions.responseType = 'arraybuffer'

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damagecasesIdWorkingimagesDownloadPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to get all workingimages of a specific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdWorkingimagesGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdWorkingimagesGet', 'id', id)
            const localVarPath = `/damagecases/{id}/workingimages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to update a workingimage
         * @param {number} id 
         * @param {number} imageId 
         * @param {WorkingImages} workingImages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdWorkingimagesImageIdPut: async (id: number, imageId: number, workingImages: WorkingImages, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdWorkingimagesImageIdPut', 'id', id)
            // verify required parameter 'imageId' is not null or undefined
            assertParamExists('damagecasesIdWorkingimagesImageIdPut', 'imageId', imageId)
            // verify required parameter 'workingImages' is not null or undefined
            assertParamExists('damagecasesIdWorkingimagesImageIdPut', 'workingImages', workingImages)
            const localVarPath = `/damagecases/{id}/workingimages/{image_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"image_id"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workingImages, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to add a new workingimage to a damage case
         * @param {number} id 
         * @param {WorkingImages} workingImages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdWorkingimagesPost: async (id: number, workingImages: WorkingImages, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damagecasesIdWorkingimagesPost', 'id', id)
            // verify required parameter 'workingImages' is not null or undefined
            assertParamExists('damagecasesIdWorkingimagesPost', 'workingImages', workingImages)
            const localVarPath = `/damagecases/{id}/workingimages`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workingImages, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new damage case as order documentation
         * @param {CreateDamageCase} createDamageCase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesOrderDocumentationPost: async (createDamageCase: CreateDamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDamageCase' is not null or undefined
            assertParamExists('damagecasesOrderDocumentationPost', 'createDamageCase', createDamageCase)
            const localVarPath = `/damagecases/order_documentation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDamageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesStatisticsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/damagecases/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of documents of this damagecase
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecaseDocumentlistIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecaseDocumentlistIdGet', 'id', id)
            const localVarPath = `/pdf/damagecase/documentlist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all customer signing requests
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdAllSignableDocumentGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdAllSignableDocumentGet', 'id', id)
            const localVarPath = `/pdf/damagecases/{id}/all/signableDocument`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove all files by type from damagecase
         * @param {number} id DamageCase ID
         * @param {PDFTypes} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdRemoveTypeDelete: async (id: number, type: PDFTypes, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdRemoveTypeDelete', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesIdRemoveTypeDelete', 'type', type)
            const localVarPath = `/pdf/damagecases/{id}/remove/{type}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Post new customer sign request
         * @param {string} id 
         * @param {DocumentSign} [documentSign] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdSignableDocumentPost: async (id: string, documentSign?: DocumentSign, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdSignableDocumentPost', 'id', id)
            const localVarPath = `/pdf/damagecases/{id}/signableDocument`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentSign, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download AppEmployeeDatasheet
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTempQrsheetGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdTempQrsheetGet', 'id', id)
            const localVarPath = `/pdf/damagecases/{id}/temp/qrsheet`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the last uuid of documents with this type
         * @param {number} id 
         * @param {PDFTypes} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeGet: async (id: number, type: PDFTypes, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeGet', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeGet', 'type', type)
            const localVarPath = `/pdf/damagecases/{id}/{type}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} label 
         * @param {string} [miscoverride] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeUploadLabelPost: async (id: string, type: string, label: string, miscoverride?: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadLabelPost', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadLabelPost', 'type', type)
            // verify required parameter 'label' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadLabelPost', 'label', label)
            const localVarPath = `/pdf/damagecases/{id}/{type}/upload/{label}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"label"}}`, encodeURIComponent(String(label)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (miscoverride !== undefined) {
                localVarQueryParameter['miscoverride'] = miscoverride;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeUploadPost: async (id: string, type: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadPost', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadPost', 'type', type)
            const localVarPath = `/pdf/damagecases/{id}/{type}/upload`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} repairExtensionId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost: async (id: string, type: string, repairExtensionId: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost', 'type', type)
            // verify required parameter 'repairExtensionId' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost', 'repairExtensionId', repairExtensionId)
            const localVarPath = `/pdf/damagecases/{id}/{type}/upload/repairExtension/{repairExtensionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"repairExtensionId"}}`, encodeURIComponent(String(repairExtensionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the uuid of the pdf file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesPaymentTypeSavePost: async (type: PDFTypes, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesPaymentTypeSavePost', 'type', type)
            const localVarPath = `/pdf/damagecases/payment/{type}/save`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesPaymentTypeTempPost: async (type: PDFTypes, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesPaymentTypeTempPost', 'type', type)
            const localVarPath = `/pdf/damagecases/payment/{type}/temp`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the uuid of the pdf file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesTypeSavePost: async (type: PDFTypes, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesTypeSavePost', 'type', type)
            const localVarPath = `/pdf/damagecases/{type}/save`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesTypeTempSavePost: async (type: PDFTypes, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesTypeTempSavePost', 'type', type)
            const localVarPath = `/pdf/damagecases/{type}/temp/save`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the file of the document
         * @param {string} uuid 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesUuidFileGet: async (uuid: string, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('pdfDamagecasesUuidFileGet', 'uuid', uuid)
            const localVarPath = `/pdf/damagecases/{uuid}/file`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the temp file of the document
         * @param {string} uuid 
         * @param {string} [filename] 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesUuidTempFileGet: async (uuid: string, filename?: string, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('pdfDamagecasesUuidTempFileGet', 'uuid', uuid)
            const localVarPath = `/pdf/damagecases/{uuid}/temp/file`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DamagecasesApi - functional programming interface
 * @export
 */
export const DamagecasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DamagecasesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new damage case
         * @param {CreateDamageCase} createDamageCase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDamageCases(createDamageCase: CreateDamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDamageCases(createDamageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create damage case (comprehensive)
         * @param {DamageCaseComprehensive} [damageCaseComprehensive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesComprehensivePost(damageCaseComprehensive?: DamageCaseComprehensive, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesComprehensivePost(damageCaseComprehensive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all damage cases
         * @param {number} [page] Pagenumber
         * @param {number} [perPage] Items shown per page
         * @param {string} [sort] Column to Sort example: date_of_accident, for desc -date_of_accident
         * @param {string} [filterDaterange] Daterangefilter e.g. 1600696856-1620692324
         * @param {string} [filterYear] Yearfilter e.g. 2020
         * @param {string} [filterStatus] 
         * @param {string} [filterDamageAssessorReferenceNumber] 
         * @param {string} [filterLawyersOfficeReferenceNumber] 
         * @param {string} [filterRepairShopReferenceNumber] 
         * @param {string} [filterVehicles] 
         * @param {string} [filterImdNet] 
         * @param {number} [filterCustomer] 
         * @param {string} [filterPayment] 
         * @param {string} [filterDamageAssessor] 
         * @param {string} [filterRepairshop] 
         * @param {string} [filterIntermediary] 
         * @param {string} [filterIsEmployee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesGet(page?: number, perPage?: number, sort?: string, filterDaterange?: string, filterYear?: string, filterStatus?: string, filterDamageAssessorReferenceNumber?: string, filterLawyersOfficeReferenceNumber?: string, filterRepairShopReferenceNumber?: string, filterVehicles?: string, filterImdNet?: string, filterCustomer?: number, filterPayment?: string, filterDamageAssessor?: string, filterRepairshop?: string, filterIntermediary?: string, filterIsEmployee?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DamageCase>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesGet(page, perPage, sort, filterDaterange, filterYear, filterStatus, filterDamageAssessorReferenceNumber, filterLawyersOfficeReferenceNumber, filterRepairShopReferenceNumber, filterVehicles, filterImdNet, filterCustomer, filterPayment, filterDamageAssessor, filterRepairshop, filterIntermediary, filterIsEmployee, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update CustomerConsultant in DamageCase
         * @param {number} id 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdCustomerConsultantPut(id: number, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdCustomerConsultantPut(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download the file of the document
         * @param {number} id 
         * @param {number} docid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdDocumentsDocidFileGet(id: number, docid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdDocumentsDocidFileGet(id, docid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload the file of the document
         * @param {number} id 
         * @param {number} docid 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdDocumentsDocidFilePost(id: number, docid: number, body?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdDocumentsDocidFilePost(id, docid, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a specific docuemnt for a specific damagecase
         * @param {number} id 
         * @param {number} docid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdDocumentsDocidGet(id: number, docid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdDocumentsDocidGet(id, docid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific docuemnt for a specific damagecase
         * @param {number} id 
         * @param {number} docid 
         * @param {Document} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdDocumentsDocidPut(id: number, docid: number, document: Document, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdDocumentsDocidPut(id, docid, document, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all documents of a specific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdDocumentsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Document>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdDocumentsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new DokumentDTO for a specific damage case
         * @param {number} id 
         * @param {Document} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdDocumentsPost(id: number, document: Document, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdDocumentsPost(id, document, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download the file of the document
         * @param {number} id 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdDocumentsTypeGet(id: number, type: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdDocumentsTypeGet(id, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Mail all documents of damagecase
         * @param {number} id The id of the damageCase to retrieve
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdEmailEmailGet(id: number, email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdEmailEmailGet(id, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Mail all updated documents of damagecase
         * @param {number} id The id of the damageCase to retrieve
         * @param {string} email 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdEmailEmailUpdatePost(id: number, email: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdEmailEmailUpdatePost(id, email, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a specific damage case
         * @param {number} id The id of the damageCase to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to download all types of images of a specific damage case
         * @param {number} id 
         * @param {'thumbnail' | 'workingimages'} imageType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdImageTypeGet(id: number, imageType: 'thumbnail' | 'workingimages', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MetaInfoFile>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdImageTypeGet(id, imageType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload the thumbnail of a specific damage case
         * @param {number} id 
         * @param {'thumbnail' | 'workingimages'} imageType 
         * @param {MetaInfoFile} metaInfoFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdImageTypePost(id: number, imageType: 'thumbnail' | 'workingimages', metaInfoFile: MetaInfoFile, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdImageTypePost(id, imageType, metaInfoFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific lawyer office
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdLawyerOfficePut(id: number, company?: Company, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdLawyerOfficePut(id, company, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Remove lawyer office
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdLawyerOfficeRemovePut(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdLawyerOfficeRemovePut(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update damagecase note
         * @param {number} id 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdNotePut(id: number, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdNotePut(id, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific opposite Insurances
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdOppositeInsurancePut(id: number, company?: Company, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdOppositeInsurancePut(id, company, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific damage case
         * @param {number} id 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdPut(id: number, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DamageCase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdPut(id, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific RepairShop
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRepairShopPut(id: number, company?: Company, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRepairShopPut(id, company, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sent E-Mail to context-Lawyer
         * @param {number} id 
         * @param {DamagecasesIdRepairextensionsEmailLawyerOfficePostRequest} damagecasesIdRepairextensionsEmailLawyerOfficePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRepairextensionsEmailLawyerOfficePost(id: number, damagecasesIdRepairextensionsEmailLawyerOfficePostRequest: DamagecasesIdRepairextensionsEmailLawyerOfficePostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRepairextensionsEmailLawyerOfficePost(id, damagecasesIdRepairextensionsEmailLawyerOfficePostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to get a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRepairextensionsExtidGet(id: number, extid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairExtension>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRepairextensionsExtidGet(id, extid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to get a secific collection of media as a zip of a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {DamagecasesIdWorkingimagesDownloadPostRequest} damagecasesIdWorkingimagesDownloadPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRepairextensionsExtidMediafilesDownloadGet(id: number, extid: number, damagecasesIdWorkingimagesDownloadPostRequest: DamagecasesIdWorkingimagesDownloadPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRepairextensionsExtidMediafilesDownloadGet(id, extid, damagecasesIdWorkingimagesDownloadPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to get all media files of a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRepairextensionsExtidMediafilesGet(id: number, extid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MetaInfoFile>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRepairextensionsExtidMediafilesGet(id, extid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to upload a media-file to a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {MetaInfoFile} metaInfoFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRepairextensionsExtidMediafilesPost(id: number, extid: number, metaInfoFile: MetaInfoFile, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRepairextensionsExtidMediafilesPost(id, extid, metaInfoFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to update a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {RepairExtension} repairExtension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRepairextensionsExtidPut(id: number, extid: number, repairExtension: RepairExtension, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairExtension>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRepairextensionsExtidPut(id, extid, repairExtension, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to get all repair extensions of a specific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRepairextensionsGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RepairExtension>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRepairextensionsGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to add a new repair extension to a damage case
         * @param {number} id 
         * @param {RepairExtension} repairExtension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRepairextensionsPost(id: number, repairExtension: RepairExtension, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRepairextensionsPost(id, repairExtension, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to download all images of the repair proof to a secific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRepairproofDownloadGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRepairproofDownloadGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to download the repair proof of a specific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRepairproofGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairProof>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRepairproofGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload the repair proof of a specific damage case
         * @param {number} id 
         * @param {RepairProof} repairProof 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdRepairproofPost(id: number, repairProof: RepairProof, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdRepairproofPost(id, repairProof, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get Text from api
         * @param {string} type 
         * @param {number} id The id of the damageCase to retrieve
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdTextgeneratorTypePost(type: string, id: number, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdTextgeneratorTypePost(type, id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to delete a workingimage
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdWorkingimagesDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdWorkingimagesDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to get a secific collection of workingimges as a zip of a specific damage case
         * @param {number} id 
         * @param {DamagecasesIdWorkingimagesDownloadPostRequest} damagecasesIdWorkingimagesDownloadPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdWorkingimagesDownloadPost(id: number, damagecasesIdWorkingimagesDownloadPostRequest: DamagecasesIdWorkingimagesDownloadPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdWorkingimagesDownloadPost(id, damagecasesIdWorkingimagesDownloadPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to get all workingimages of a specific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdWorkingimagesGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingImages>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdWorkingimagesGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to update a workingimage
         * @param {number} id 
         * @param {number} imageId 
         * @param {WorkingImages} workingImages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdWorkingimagesImageIdPut(id: number, imageId: number, workingImages: WorkingImages, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdWorkingimagesImageIdPut(id, imageId, workingImages, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to add a new workingimage to a damage case
         * @param {number} id 
         * @param {WorkingImages} workingImages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesIdWorkingimagesPost(id: number, workingImages: WorkingImages, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesIdWorkingimagesPost(id, workingImages, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new damage case as order documentation
         * @param {CreateDamageCase} createDamageCase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesOrderDocumentationPost(createDamageCase: CreateDamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesOrderDocumentationPost(createDamageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesStatisticsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DamageCase>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesStatisticsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a list of documents of this damagecase
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecaseDocumentlistIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecaseDocumentlistIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all customer signing requests
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdAllSignableDocumentGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdAllSignableDocumentGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Remove all files by type from damagecase
         * @param {number} id DamageCase ID
         * @param {PDFTypes} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdRemoveTypeDelete(id: number, type: PDFTypes, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdRemoveTypeDelete(id, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Post new customer sign request
         * @param {string} id 
         * @param {DocumentSign} [documentSign] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdSignableDocumentPost(id: string, documentSign?: DocumentSign, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdSignableDocumentPost(id, documentSign, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download AppEmployeeDatasheet
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdTempQrsheetGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdTempQrsheetGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the last uuid of documents with this type
         * @param {number} id 
         * @param {PDFTypes} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdTypeGet(id: number, type: PDFTypes, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdTypeGet(id, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} label 
         * @param {string} [miscoverride] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdTypeUploadLabelPost(id: string, type: string, label: string, miscoverride?: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdTypeUploadLabelPost(id, type, label, miscoverride, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdTypeUploadPost(id: string, type: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdTypeUploadPost(id, type, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} repairExtensionId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost(id: string, type: string, repairExtensionId: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost(id, type, repairExtensionId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the uuid of the pdf file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesPaymentTypeSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfDamagecasesTypeTempSavePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesPaymentTypeSavePost(type, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesPaymentTypeTempPost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfDamagecasesTypeTempSavePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesPaymentTypeTempPost(type, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the uuid of the pdf file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesTypeSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfDamagecasesTypeTempSavePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesTypeSavePost(type, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesTypeTempSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfDamagecasesTypeTempSavePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesTypeTempSavePost(type, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download the file of the document
         * @param {string} uuid 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesUuidFileGet(uuid: string, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesUuidFileGet(uuid, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download the temp file of the document
         * @param {string} uuid 
         * @param {string} [filename] 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesUuidTempFileGet(uuid: string, filename?: string, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesUuidTempFileGet(uuid, filename, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DamagecasesApi - factory interface
 * @export
 */
export const DamagecasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DamagecasesApiFp(configuration)
    return {
        /**
         * Create a new damage case
         * @param {CreateDamageCase} createDamageCase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDamageCases(createDamageCase: CreateDamageCase, options?: any): AxiosPromise<void> {
            return localVarFp.createDamageCases(createDamageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Create damage case (comprehensive)
         * @param {DamageCaseComprehensive} [damageCaseComprehensive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesComprehensivePost(damageCaseComprehensive?: DamageCaseComprehensive, options?: any): AxiosPromise<DamageCase> {
            return localVarFp.damagecasesComprehensivePost(damageCaseComprehensive, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all damage cases
         * @param {number} [page] Pagenumber
         * @param {number} [perPage] Items shown per page
         * @param {string} [sort] Column to Sort example: date_of_accident, for desc -date_of_accident
         * @param {string} [filterDaterange] Daterangefilter e.g. 1600696856-1620692324
         * @param {string} [filterYear] Yearfilter e.g. 2020
         * @param {string} [filterStatus] 
         * @param {string} [filterDamageAssessorReferenceNumber] 
         * @param {string} [filterLawyersOfficeReferenceNumber] 
         * @param {string} [filterRepairShopReferenceNumber] 
         * @param {string} [filterVehicles] 
         * @param {string} [filterImdNet] 
         * @param {number} [filterCustomer] 
         * @param {string} [filterPayment] 
         * @param {string} [filterDamageAssessor] 
         * @param {string} [filterRepairshop] 
         * @param {string} [filterIntermediary] 
         * @param {string} [filterIsEmployee] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesGet(page?: number, perPage?: number, sort?: string, filterDaterange?: string, filterYear?: string, filterStatus?: string, filterDamageAssessorReferenceNumber?: string, filterLawyersOfficeReferenceNumber?: string, filterRepairShopReferenceNumber?: string, filterVehicles?: string, filterImdNet?: string, filterCustomer?: number, filterPayment?: string, filterDamageAssessor?: string, filterRepairshop?: string, filterIntermediary?: string, filterIsEmployee?: string, options?: any): AxiosPromise<Array<DamageCase>> {
            return localVarFp.damagecasesGet(page, perPage, sort, filterDaterange, filterYear, filterStatus, filterDamageAssessorReferenceNumber, filterLawyersOfficeReferenceNumber, filterRepairShopReferenceNumber, filterVehicles, filterImdNet, filterCustomer, filterPayment, filterDamageAssessor, filterRepairshop, filterIntermediary, filterIsEmployee, options).then((request) => request(axios, basePath));
        },
        /**
         * Update CustomerConsultant in DamageCase
         * @param {number} id 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdCustomerConsultantPut(id: number, body?: string, options?: any): AxiosPromise<string> {
            return localVarFp.damagecasesIdCustomerConsultantPut(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the file of the document
         * @param {number} id 
         * @param {number} docid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsDocidFileGet(id: number, docid: number, options?: any): AxiosPromise<any> {
            return localVarFp.damagecasesIdDocumentsDocidFileGet(id, docid, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload the file of the document
         * @param {number} id 
         * @param {number} docid 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsDocidFilePost(id: number, docid: number, body?: any, options?: any): AxiosPromise<any> {
            return localVarFp.damagecasesIdDocumentsDocidFilePost(id, docid, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific docuemnt for a specific damagecase
         * @param {number} id 
         * @param {number} docid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsDocidGet(id: number, docid: number, options?: any): AxiosPromise<Document> {
            return localVarFp.damagecasesIdDocumentsDocidGet(id, docid, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific docuemnt for a specific damagecase
         * @param {number} id 
         * @param {number} docid 
         * @param {Document} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsDocidPut(id: number, docid: number, document: Document, options?: any): AxiosPromise<Document> {
            return localVarFp.damagecasesIdDocumentsDocidPut(id, docid, document, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all documents of a specific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsGet(id: number, options?: any): AxiosPromise<Array<Document>> {
            return localVarFp.damagecasesIdDocumentsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new DokumentDTO for a specific damage case
         * @param {number} id 
         * @param {Document} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsPost(id: number, document: Document, options?: any): AxiosPromise<Document> {
            return localVarFp.damagecasesIdDocumentsPost(id, document, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the file of the document
         * @param {number} id 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdDocumentsTypeGet(id: number, type: string, options?: any): AxiosPromise<any> {
            return localVarFp.damagecasesIdDocumentsTypeGet(id, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Mail all documents of damagecase
         * @param {number} id The id of the damageCase to retrieve
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdEmailEmailGet(id: number, email: string, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesIdEmailEmailGet(id, email, options).then((request) => request(axios, basePath));
        },
        /**
         * Mail all updated documents of damagecase
         * @param {number} id The id of the damageCase to retrieve
         * @param {string} email 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdEmailEmailUpdatePost(id: number, email: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesIdEmailEmailUpdatePost(id, email, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific damage case
         * @param {number} id The id of the damageCase to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdGet(id: number, options?: any): AxiosPromise<DamageCase> {
            return localVarFp.damagecasesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to download all types of images of a specific damage case
         * @param {number} id 
         * @param {'thumbnail' | 'workingimages'} imageType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdImageTypeGet(id: number, imageType: 'thumbnail' | 'workingimages', options?: any): AxiosPromise<Array<MetaInfoFile>> {
            return localVarFp.damagecasesIdImageTypeGet(id, imageType, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload the thumbnail of a specific damage case
         * @param {number} id 
         * @param {'thumbnail' | 'workingimages'} imageType 
         * @param {MetaInfoFile} metaInfoFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdImageTypePost(id: number, imageType: 'thumbnail' | 'workingimages', metaInfoFile: MetaInfoFile, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesIdImageTypePost(id, imageType, metaInfoFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific lawyer office
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdLawyerOfficePut(id: number, company?: Company, options?: any): AxiosPromise<Company> {
            return localVarFp.damagecasesIdLawyerOfficePut(id, company, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove lawyer office
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdLawyerOfficeRemovePut(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesIdLawyerOfficeRemovePut(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update damagecase note
         * @param {number} id 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdNotePut(id: number, damageCase?: DamageCase, options?: any): AxiosPromise<DamageCase> {
            return localVarFp.damagecasesIdNotePut(id, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific opposite Insurances
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdOppositeInsurancePut(id: number, company?: Company, options?: any): AxiosPromise<Company> {
            return localVarFp.damagecasesIdOppositeInsurancePut(id, company, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific damage case
         * @param {number} id 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdPut(id: number, damageCase?: DamageCase, options?: any): AxiosPromise<DamageCase> {
            return localVarFp.damagecasesIdPut(id, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific RepairShop
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairShopPut(id: number, company?: Company, options?: any): AxiosPromise<Company> {
            return localVarFp.damagecasesIdRepairShopPut(id, company, options).then((request) => request(axios, basePath));
        },
        /**
         * Sent E-Mail to context-Lawyer
         * @param {number} id 
         * @param {DamagecasesIdRepairextensionsEmailLawyerOfficePostRequest} damagecasesIdRepairextensionsEmailLawyerOfficePostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsEmailLawyerOfficePost(id: number, damagecasesIdRepairextensionsEmailLawyerOfficePostRequest: DamagecasesIdRepairextensionsEmailLawyerOfficePostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesIdRepairextensionsEmailLawyerOfficePost(id, damagecasesIdRepairextensionsEmailLawyerOfficePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to get a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsExtidGet(id: number, extid: number, options?: any): AxiosPromise<RepairExtension> {
            return localVarFp.damagecasesIdRepairextensionsExtidGet(id, extid, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to get a secific collection of media as a zip of a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {DamagecasesIdWorkingimagesDownloadPostRequest} damagecasesIdWorkingimagesDownloadPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsExtidMediafilesDownloadGet(id: number, extid: number, damagecasesIdWorkingimagesDownloadPostRequest: DamagecasesIdWorkingimagesDownloadPostRequest, options?: any): AxiosPromise<any> {
            return localVarFp.damagecasesIdRepairextensionsExtidMediafilesDownloadGet(id, extid, damagecasesIdWorkingimagesDownloadPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to get all media files of a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsExtidMediafilesGet(id: number, extid: number, options?: any): AxiosPromise<Array<MetaInfoFile>> {
            return localVarFp.damagecasesIdRepairextensionsExtidMediafilesGet(id, extid, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to upload a media-file to a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {MetaInfoFile} metaInfoFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsExtidMediafilesPost(id: number, extid: number, metaInfoFile: MetaInfoFile, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesIdRepairextensionsExtidMediafilesPost(id, extid, metaInfoFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to update a secific repair extension of a specific damage case
         * @param {number} id 
         * @param {number} extid 
         * @param {RepairExtension} repairExtension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsExtidPut(id: number, extid: number, repairExtension: RepairExtension, options?: any): AxiosPromise<RepairExtension> {
            return localVarFp.damagecasesIdRepairextensionsExtidPut(id, extid, repairExtension, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to get all repair extensions of a specific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsGet(id: number, options?: any): AxiosPromise<Array<RepairExtension>> {
            return localVarFp.damagecasesIdRepairextensionsGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to add a new repair extension to a damage case
         * @param {number} id 
         * @param {RepairExtension} repairExtension 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairextensionsPost(id: number, repairExtension: RepairExtension, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesIdRepairextensionsPost(id, repairExtension, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to download all images of the repair proof to a secific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairproofDownloadGet(id: number, options?: any): AxiosPromise<any> {
            return localVarFp.damagecasesIdRepairproofDownloadGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to download the repair proof of a specific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairproofGet(id: number, options?: any): AxiosPromise<RepairProof> {
            return localVarFp.damagecasesIdRepairproofGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload the repair proof of a specific damage case
         * @param {number} id 
         * @param {RepairProof} repairProof 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdRepairproofPost(id: number, repairProof: RepairProof, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesIdRepairproofPost(id, repairProof, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Text from api
         * @param {string} type 
         * @param {number} id The id of the damageCase to retrieve
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdTextgeneratorTypePost(type: string, id: number, body?: object, options?: any): AxiosPromise<string> {
            return localVarFp.damagecasesIdTextgeneratorTypePost(type, id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to delete a workingimage
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdWorkingimagesDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesIdWorkingimagesDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to get a secific collection of workingimges as a zip of a specific damage case
         * @param {number} id 
         * @param {DamagecasesIdWorkingimagesDownloadPostRequest} damagecasesIdWorkingimagesDownloadPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdWorkingimagesDownloadPost(id: number, damagecasesIdWorkingimagesDownloadPostRequest: DamagecasesIdWorkingimagesDownloadPostRequest, options?: any): AxiosPromise<any> {
            return localVarFp.damagecasesIdWorkingimagesDownloadPost(id, damagecasesIdWorkingimagesDownloadPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to get all workingimages of a specific damage case
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdWorkingimagesGet(id: number, options?: any): AxiosPromise<Array<WorkingImages>> {
            return localVarFp.damagecasesIdWorkingimagesGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to update a workingimage
         * @param {number} id 
         * @param {number} imageId 
         * @param {WorkingImages} workingImages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdWorkingimagesImageIdPut(id: number, imageId: number, workingImages: WorkingImages, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesIdWorkingimagesImageIdPut(id, imageId, workingImages, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to add a new workingimage to a damage case
         * @param {number} id 
         * @param {WorkingImages} workingImages 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesIdWorkingimagesPost(id: number, workingImages: WorkingImages, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesIdWorkingimagesPost(id, workingImages, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new damage case as order documentation
         * @param {CreateDamageCase} createDamageCase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesOrderDocumentationPost(createDamageCase: CreateDamageCase, options?: any): AxiosPromise<void> {
            return localVarFp.damagecasesOrderDocumentationPost(createDamageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesStatisticsGet(options?: any): AxiosPromise<Array<DamageCase>> {
            return localVarFp.damagecasesStatisticsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of documents of this damagecase
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecaseDocumentlistIdGet(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.pdfDamagecaseDocumentlistIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all customer signing requests
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdAllSignableDocumentGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.pdfDamagecasesIdAllSignableDocumentGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove all files by type from damagecase
         * @param {number} id DamageCase ID
         * @param {PDFTypes} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdRemoveTypeDelete(id: number, type: PDFTypes, options?: any): AxiosPromise<void> {
            return localVarFp.pdfDamagecasesIdRemoveTypeDelete(id, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Post new customer sign request
         * @param {string} id 
         * @param {DocumentSign} [documentSign] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdSignableDocumentPost(id: string, documentSign?: DocumentSign, options?: any): AxiosPromise<void> {
            return localVarFp.pdfDamagecasesIdSignableDocumentPost(id, documentSign, options).then((request) => request(axios, basePath));
        },
        /**
         * Download AppEmployeeDatasheet
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTempQrsheetGet(id: string, options?: any): AxiosPromise<any> {
            return localVarFp.pdfDamagecasesIdTempQrsheetGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the last uuid of documents with this type
         * @param {number} id 
         * @param {PDFTypes} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeGet(id: number, type: PDFTypes, options?: any): AxiosPromise<any> {
            return localVarFp.pdfDamagecasesIdTypeGet(id, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} label 
         * @param {string} [miscoverride] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeUploadLabelPost(id: string, type: string, label: string, miscoverride?: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.pdfDamagecasesIdTypeUploadLabelPost(id, type, label, miscoverride, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeUploadPost(id: string, type: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.pdfDamagecasesIdTypeUploadPost(id, type, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} repairExtensionId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost(id: string, type: string, repairExtensionId: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost(id, type, repairExtensionId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the uuid of the pdf file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesPaymentTypeSavePost(type: PDFTypes, damageCase?: DamageCase, options?: any): AxiosPromise<PdfDamagecasesTypeTempSavePost200Response> {
            return localVarFp.pdfDamagecasesPaymentTypeSavePost(type, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesPaymentTypeTempPost(type: PDFTypes, damageCase?: DamageCase, options?: any): AxiosPromise<PdfDamagecasesTypeTempSavePost200Response> {
            return localVarFp.pdfDamagecasesPaymentTypeTempPost(type, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the uuid of the pdf file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesTypeSavePost(type: PDFTypes, damageCase?: DamageCase, options?: any): AxiosPromise<PdfDamagecasesTypeTempSavePost200Response> {
            return localVarFp.pdfDamagecasesTypeSavePost(type, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesTypeTempSavePost(type: PDFTypes, damageCase?: DamageCase, options?: any): AxiosPromise<PdfDamagecasesTypeTempSavePost200Response> {
            return localVarFp.pdfDamagecasesTypeTempSavePost(type, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the file of the document
         * @param {string} uuid 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesUuidFileGet(uuid: string, damageCase?: DamageCase, options?: any): AxiosPromise<any> {
            return localVarFp.pdfDamagecasesUuidFileGet(uuid, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the temp file of the document
         * @param {string} uuid 
         * @param {string} [filename] 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesUuidTempFileGet(uuid: string, filename?: string, damageCase?: DamageCase, options?: any): AxiosPromise<any> {
            return localVarFp.pdfDamagecasesUuidTempFileGet(uuid, filename, damageCase, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DamagecasesApi - object-oriented interface
 * @export
 * @class DamagecasesApi
 * @extends {BaseAPI}
 */
export class DamagecasesApi extends BaseAPI {
    /**
     * Create a new damage case
     * @param {CreateDamageCase} createDamageCase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public createDamageCases(createDamageCase: CreateDamageCase, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).createDamageCases(createDamageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create damage case (comprehensive)
     * @param {DamageCaseComprehensive} [damageCaseComprehensive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesComprehensivePost(damageCaseComprehensive?: DamageCaseComprehensive, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesComprehensivePost(damageCaseComprehensive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all damage cases
     * @param {number} [page] Pagenumber
     * @param {number} [perPage] Items shown per page
     * @param {string} [sort] Column to Sort example: date_of_accident, for desc -date_of_accident
     * @param {string} [filterDaterange] Daterangefilter e.g. 1600696856-1620692324
     * @param {string} [filterYear] Yearfilter e.g. 2020
     * @param {string} [filterStatus] 
     * @param {string} [filterDamageAssessorReferenceNumber] 
     * @param {string} [filterLawyersOfficeReferenceNumber] 
     * @param {string} [filterRepairShopReferenceNumber] 
     * @param {string} [filterVehicles] 
     * @param {string} [filterImdNet] 
     * @param {number} [filterCustomer] 
     * @param {string} [filterPayment] 
     * @param {string} [filterDamageAssessor] 
     * @param {string} [filterRepairshop] 
     * @param {string} [filterIntermediary] 
     * @param {string} [filterIsEmployee] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesGet(page?: number, perPage?: number, sort?: string, filterDaterange?: string, filterYear?: string, filterStatus?: string, filterDamageAssessorReferenceNumber?: string, filterLawyersOfficeReferenceNumber?: string, filterRepairShopReferenceNumber?: string, filterVehicles?: string, filterImdNet?: string, filterCustomer?: number, filterPayment?: string, filterDamageAssessor?: string, filterRepairshop?: string, filterIntermediary?: string, filterIsEmployee?: string, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesGet(page, perPage, sort, filterDaterange, filterYear, filterStatus, filterDamageAssessorReferenceNumber, filterLawyersOfficeReferenceNumber, filterRepairShopReferenceNumber, filterVehicles, filterImdNet, filterCustomer, filterPayment, filterDamageAssessor, filterRepairshop, filterIntermediary, filterIsEmployee, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update CustomerConsultant in DamageCase
     * @param {number} id 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdCustomerConsultantPut(id: number, body?: string, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdCustomerConsultantPut(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download the file of the document
     * @param {number} id 
     * @param {number} docid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdDocumentsDocidFileGet(id: number, docid: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdDocumentsDocidFileGet(id, docid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload the file of the document
     * @param {number} id 
     * @param {number} docid 
     * @param {any} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdDocumentsDocidFilePost(id: number, docid: number, body?: any, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdDocumentsDocidFilePost(id, docid, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific docuemnt for a specific damagecase
     * @param {number} id 
     * @param {number} docid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdDocumentsDocidGet(id: number, docid: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdDocumentsDocidGet(id, docid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific docuemnt for a specific damagecase
     * @param {number} id 
     * @param {number} docid 
     * @param {Document} document 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdDocumentsDocidPut(id: number, docid: number, document: Document, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdDocumentsDocidPut(id, docid, document, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all documents of a specific damage case
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdDocumentsGet(id: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdDocumentsGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new DokumentDTO for a specific damage case
     * @param {number} id 
     * @param {Document} document 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdDocumentsPost(id: number, document: Document, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdDocumentsPost(id, document, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download the file of the document
     * @param {number} id 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdDocumentsTypeGet(id: number, type: string, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdDocumentsTypeGet(id, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mail all documents of damagecase
     * @param {number} id The id of the damageCase to retrieve
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdEmailEmailGet(id: number, email: string, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdEmailEmailGet(id, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mail all updated documents of damagecase
     * @param {number} id The id of the damageCase to retrieve
     * @param {string} email 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdEmailEmailUpdatePost(id: number, email: string, body?: string, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdEmailEmailUpdatePost(id, email, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific damage case
     * @param {number} id The id of the damageCase to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdGet(id: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to download all types of images of a specific damage case
     * @param {number} id 
     * @param {'thumbnail' | 'workingimages'} imageType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdImageTypeGet(id: number, imageType: 'thumbnail' | 'workingimages', options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdImageTypeGet(id, imageType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload the thumbnail of a specific damage case
     * @param {number} id 
     * @param {'thumbnail' | 'workingimages'} imageType 
     * @param {MetaInfoFile} metaInfoFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdImageTypePost(id: number, imageType: 'thumbnail' | 'workingimages', metaInfoFile: MetaInfoFile, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdImageTypePost(id, imageType, metaInfoFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific lawyer office
     * @param {number} id 
     * @param {Company} [company] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdLawyerOfficePut(id: number, company?: Company, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdLawyerOfficePut(id, company, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove lawyer office
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdLawyerOfficeRemovePut(id: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdLawyerOfficeRemovePut(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update damagecase note
     * @param {number} id 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdNotePut(id: number, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdNotePut(id, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific opposite Insurances
     * @param {number} id 
     * @param {Company} [company] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdOppositeInsurancePut(id: number, company?: Company, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdOppositeInsurancePut(id, company, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific damage case
     * @param {number} id 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdPut(id: number, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdPut(id, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific RepairShop
     * @param {number} id 
     * @param {Company} [company] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdRepairShopPut(id: number, company?: Company, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdRepairShopPut(id, company, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sent E-Mail to context-Lawyer
     * @param {number} id 
     * @param {DamagecasesIdRepairextensionsEmailLawyerOfficePostRequest} damagecasesIdRepairextensionsEmailLawyerOfficePostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdRepairextensionsEmailLawyerOfficePost(id: number, damagecasesIdRepairextensionsEmailLawyerOfficePostRequest: DamagecasesIdRepairextensionsEmailLawyerOfficePostRequest, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdRepairextensionsEmailLawyerOfficePost(id, damagecasesIdRepairextensionsEmailLawyerOfficePostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to get a secific repair extension of a specific damage case
     * @param {number} id 
     * @param {number} extid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdRepairextensionsExtidGet(id: number, extid: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdRepairextensionsExtidGet(id, extid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to get a secific collection of media as a zip of a secific repair extension of a specific damage case
     * @param {number} id 
     * @param {number} extid 
     * @param {DamagecasesIdWorkingimagesDownloadPostRequest} damagecasesIdWorkingimagesDownloadPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdRepairextensionsExtidMediafilesDownloadGet(id: number, extid: number, damagecasesIdWorkingimagesDownloadPostRequest: DamagecasesIdWorkingimagesDownloadPostRequest, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdRepairextensionsExtidMediafilesDownloadGet(id, extid, damagecasesIdWorkingimagesDownloadPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to get all media files of a secific repair extension of a specific damage case
     * @param {number} id 
     * @param {number} extid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdRepairextensionsExtidMediafilesGet(id: number, extid: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdRepairextensionsExtidMediafilesGet(id, extid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to upload a media-file to a secific repair extension of a specific damage case
     * @param {number} id 
     * @param {number} extid 
     * @param {MetaInfoFile} metaInfoFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdRepairextensionsExtidMediafilesPost(id: number, extid: number, metaInfoFile: MetaInfoFile, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdRepairextensionsExtidMediafilesPost(id, extid, metaInfoFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to update a secific repair extension of a specific damage case
     * @param {number} id 
     * @param {number} extid 
     * @param {RepairExtension} repairExtension 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdRepairextensionsExtidPut(id: number, extid: number, repairExtension: RepairExtension, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdRepairextensionsExtidPut(id, extid, repairExtension, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to get all repair extensions of a specific damage case
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdRepairextensionsGet(id: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdRepairextensionsGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to add a new repair extension to a damage case
     * @param {number} id 
     * @param {RepairExtension} repairExtension 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdRepairextensionsPost(id: number, repairExtension: RepairExtension, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdRepairextensionsPost(id, repairExtension, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to download all images of the repair proof to a secific damage case
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdRepairproofDownloadGet(id: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdRepairproofDownloadGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to download the repair proof of a specific damage case
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdRepairproofGet(id: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdRepairproofGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload the repair proof of a specific damage case
     * @param {number} id 
     * @param {RepairProof} repairProof 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdRepairproofPost(id: number, repairProof: RepairProof, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdRepairproofPost(id, repairProof, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Text from api
     * @param {string} type 
     * @param {number} id The id of the damageCase to retrieve
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdTextgeneratorTypePost(type: string, id: number, body?: object, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdTextgeneratorTypePost(type, id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to delete a workingimage
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdWorkingimagesDelete(id: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdWorkingimagesDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to get a secific collection of workingimges as a zip of a specific damage case
     * @param {number} id 
     * @param {DamagecasesIdWorkingimagesDownloadPostRequest} damagecasesIdWorkingimagesDownloadPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdWorkingimagesDownloadPost(id: number, damagecasesIdWorkingimagesDownloadPostRequest: DamagecasesIdWorkingimagesDownloadPostRequest, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdWorkingimagesDownloadPost(id, damagecasesIdWorkingimagesDownloadPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to get all workingimages of a specific damage case
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdWorkingimagesGet(id: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdWorkingimagesGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to update a workingimage
     * @param {number} id 
     * @param {number} imageId 
     * @param {WorkingImages} workingImages 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdWorkingimagesImageIdPut(id: number, imageId: number, workingImages: WorkingImages, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdWorkingimagesImageIdPut(id, imageId, workingImages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to add a new workingimage to a damage case
     * @param {number} id 
     * @param {WorkingImages} workingImages 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesIdWorkingimagesPost(id: number, workingImages: WorkingImages, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesIdWorkingimagesPost(id, workingImages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new damage case as order documentation
     * @param {CreateDamageCase} createDamageCase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesOrderDocumentationPost(createDamageCase: CreateDamageCase, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesOrderDocumentationPost(createDamageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public damagecasesStatisticsGet(options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).damagecasesStatisticsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of documents of this damagecase
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecaseDocumentlistIdGet(id: number, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecaseDocumentlistIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all customer signing requests
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesIdAllSignableDocumentGet(id: string, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesIdAllSignableDocumentGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove all files by type from damagecase
     * @param {number} id DamageCase ID
     * @param {PDFTypes} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesIdRemoveTypeDelete(id: number, type: PDFTypes, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesIdRemoveTypeDelete(id, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Post new customer sign request
     * @param {string} id 
     * @param {DocumentSign} [documentSign] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesIdSignableDocumentPost(id: string, documentSign?: DocumentSign, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesIdSignableDocumentPost(id, documentSign, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download AppEmployeeDatasheet
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesIdTempQrsheetGet(id: string, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesIdTempQrsheetGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the last uuid of documents with this type
     * @param {number} id 
     * @param {PDFTypes} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesIdTypeGet(id: number, type: PDFTypes, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesIdTypeGet(id, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload the file of the document
     * @param {string} id 
     * @param {string} type 
     * @param {string} label 
     * @param {string} [miscoverride] 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesIdTypeUploadLabelPost(id: string, type: string, label: string, miscoverride?: string, body?: string, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesIdTypeUploadLabelPost(id, type, label, miscoverride, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload the file of the document
     * @param {string} id 
     * @param {string} type 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesIdTypeUploadPost(id: string, type: string, body?: string, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesIdTypeUploadPost(id, type, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload the file of the document
     * @param {string} id 
     * @param {string} type 
     * @param {string} repairExtensionId 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost(id: string, type: string, repairExtensionId: string, body?: string, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost(id, type, repairExtensionId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the uuid of the pdf file
     * @param {PDFTypes} type 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesPaymentTypeSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesPaymentTypeSavePost(type, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the uuid of the temporary file
     * @param {PDFTypes} type 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesPaymentTypeTempPost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesPaymentTypeTempPost(type, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the uuid of the pdf file
     * @param {PDFTypes} type 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesTypeSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesTypeSavePost(type, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the uuid of the temporary file
     * @param {PDFTypes} type 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesTypeTempSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesTypeTempSavePost(type, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download the file of the document
     * @param {string} uuid 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesUuidFileGet(uuid: string, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesUuidFileGet(uuid, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download the temp file of the document
     * @param {string} uuid 
     * @param {string} [filename] 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamagecasesApi
     */
    public pdfDamagecasesUuidTempFileGet(uuid: string, filename?: string, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return DamagecasesApiFp(this.configuration).pdfDamagecasesUuidTempFileGet(uuid, filename, damageCase, options).then((request) => request(this.axios, this.basePath));
    }
}
